import * as React from "react";
const SvgTimer = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M6 1.00293H10V2.33626H6V1.00293ZM7.33333 9.6696V5.6696H8.66667V9.6696H7.33333ZM12.6867 5.25626L13.6333 4.3096C13.3467 3.9696 13.0333 3.6496 12.6933 3.3696L11.7467 4.31626C10.7133 3.4896 9.41333 2.99626 8 2.99626C4.68667 2.99626 2 5.68293 2 8.99626C2 12.3096 4.68 14.9963 8 14.9963C11.32 14.9963 14 12.3096 14 8.99626C14 7.5896 13.5067 6.2896 12.6867 5.25626ZM3.33333 9.00293C3.33333 11.5829 5.42 13.6696 8 13.6696C10.58 13.6696 12.6667 11.5829 12.6667 9.00293C12.6667 6.42293 10.58 4.33626 8 4.33626C5.42 4.33626 3.33333 6.42293 3.33333 9.00293Z",
	fill: "currentColor"
}));
export default SvgTimer;
